import axios from 'axios';
import { getValidGuestPayload } from '../common/guestToken';
import { requiresLogin } from '../common/routeAccess';

let apiUtil = {};

const concurrentRequests = {};

function handleLogin() {
    if (getValidGuestPayload() && !window.isTeams) {
        // returning guest with a still-valid token - reopen the guest login
        // dialog instead of bouncing through OAuth
        window.location.assign('/?showLogin=true');
        return;
    }
    if (window.location.host === 'localhost:3000') {
        window.location.assign('http://localhost:4000/login');
    } else if (window.location.host === '192.168.2.112:3000') {
        window.location.assign('http://192.168.2.112:4000/login');
    } else {
        if (window.location.pathname === '/login/google') {
            window.location.assign(window.location.protocol + '//' + window.location.host + '/login/google');
        } else if (window.location.pathname === '/login/facebook') {
            window.location.assign(window.location.protocol + '//' + window.location.host + '/login/facebook');
        } else if (window.location.pathname === '/login/microsoft') {
            window.location.assign(window.location.protocol + '//' + window.location.host + '/login/microsoft');
        } else if (window.location.pathname === '/login/microsoft-teams') {
            window.location.assign(window.location.protocol + '//' + window.location.host + '/login/microsoft-teams');
        } else {
            if (window.isTeams) {
                window.location.assign(
                    window.location.protocol + '//' + window.location.host + '/login/microsoft-teams',
                );
                return;
            }
            window.location.assign(window.location.protocol + '//' + window.location.host + '/login');
        }
    }
}

// A 401 only forces the login flow when the page the user is on actually
// requires one. A background 401 on a public page used to navigate to /login
// unconditionally, which - with the user already signed in to Google - bounced
// straight through OAuth and back to '/', racing the caller's own error
// handling. That is the "flash of redirect, then back to the home page,
// logged out" failure.
//
// Either way the promise rejects. Resolving with undefined made callers read
// `.data` off undefined, turning a recoverable 401 into a TypeError.
function handleRequestError(err, data) {
    if (err.request && err.request.status === 401) {
        if (requiresLogin()) {
            window.localStorage.setItem('pathBeforeLogin', window.location.pathname + window.location.search);
            handleLogin();
        }
        return Promise.reject(err);
    }
    console.error('error on call ', err.request?.status, data, err);
    return Promise.reject(err);
}

apiUtil.runRequest = function(data) {
    if (typeof data === 'string') {
        return axios.get(data).catch((err) => handleRequestError(err, data));
    } else {
        return axios(data).catch((err) => handleRequestError(err, data));
    }
};

apiUtil.runMyScript = (obj) => {
    return axios({
        url: '/api/private/management/convertSvg',
        method: 'POST',
        data: obj,
    });
};

apiUtil.loadSVG = (url) => {
    return axios({
        url: url,
    });
};

apiUtil.concurrentURLGet = (url) => {
    if (!concurrentRequests[url]) {
        concurrentRequests[url] = axios({
            url: url,
        }).then((res) => {
            concurrentRequests[url] = null;
            return res;
        });
        return concurrentRequests[url];
    } else {
        return concurrentRequests[url];
    }
};


export default apiUtil;
